import {
  ACTION_MAP,
  STORE_URLS,
  APP_URI_SCHEME,
  ANDROID_PACKAGE,
  APP_OPEN_TIMEOUT_MS,
} from "./actionConfig";

export function detectPlatform() {
  const ua = navigator.userAgent || navigator.vendor || "";
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "ios";
  if (/android/i.test(ua)) return "android";
  return "desktop";
}

export function parseDeepLinkUrl(pathname, search = "") {
  const parts = pathname.replace(/^\//, "").split("/");
  // parts[0] = "rewardstick", [1]=orgId, [2]=locationId, [3]=actionKey, [4]=appId, [5]=tillNo (optional), [6+]=extra
  const [, orgId, locationId, actionKey, appId, tillNo, ...extraParams] = parts;
  const action = ACTION_MAP[actionKey] || null;
  const queryParams = new URLSearchParams(search);
  return { orgId, locationId, actionKey, appId, tillNo, extraParams, queryParams, action, raw: parts };
}

/**
 * Returns the full original URL — this is what gets passed into the app.
 */
export function buildOriginalUrl() {
  return window.location.href;
}

/**
 * Builds the URI that opens the app, passing the full original URL as a param.
 * Format: rewardstick://open?url={encodedFullUrl}
 */
export function buildAppUri() {
  const encodedUrl = encodeURIComponent(buildOriginalUrl());
  return `${APP_URI_SCHEME}://open?url=${encodedUrl}`;
}

/**
 * Builds the Android Intent URL.
 *
 * - If app IS installed     → opens app with full URL as param
 * - If app is NOT installed → redirects to Play Store with referrer
 *   carrying the encoded URL so the app can retrieve it after install
 *   via the Play Install Referrer API.
 */
export function buildAndroidIntentUrl() {
  const fullUrl = buildOriginalUrl();
  const encodedUrl = encodeURIComponent(fullUrl);

  // Play Store URL with referrer so app can retrieve the URL after install
  const referrer = encodeURIComponent(`utm_source=qr&utm_medium=deeplink&url=${encodedUrl}`);
  const playStoreWithReferrer = `${STORE_URLS.android}&referrer=${referrer}`;

  return (
    `intent://open?url=${encodedUrl}#Intent;` +
    `scheme=${APP_URI_SCHEME};` +
    `package=${ANDROID_PACKAGE};` +
    `S.browser_fallback_url=${encodeURIComponent(playStoreWithReferrer)};` +
    `end`
  );
}

/**
 * Executes the platform-specific deep link strategy.
 *
 * Android : Intent URL — OS handles installed/not-installed natively
 * iOS     : URI scheme + visibilitychange timeout → App Store
 * Desktop : Show store options in UI
 */
export function executeDeepLink(parsed, onRedirecting) {
  const platform = detectPlatform();

  if (platform === "android") {
    onRedirecting({ platform, destination: "app_or_store" });
    window.location.href = buildAndroidIntentUrl();

  } else if (platform === "ios") {
    onRedirecting({ platform, destination: "app_attempting" });
    window.location.href = buildAppUri();

    const timer = setTimeout(() => {
      onRedirecting({ platform, destination: "store" });
      // iOS App Store with campaign token carrying the URL
      const encodedUrl = encodeURIComponent(buildOriginalUrl());
      window.location.href = `${STORE_URLS.ios}&ct=qr_deeplink&mt=8&pt=${encodedUrl}`;
    }, APP_OPEN_TIMEOUT_MS);

    document.addEventListener("visibilitychange", () => {
      if (document.hidden) clearTimeout(timer);
    }, { once: true });

  } else {
    onRedirecting({ platform, destination: "desktop" });
  }
}